export const isNullOrEmpty = (value: any[] | string): boolean => {
  if (value === null) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  return value === '';
};

// retrieve account from cookies
export const parseCookieAsJsonObject = (cookieName: string): any => {
  const accountCookie = decodeURIComponent(document.cookie)
    .split(';')
    .find((cookie: string) => cookie.indexOf(cookieName) >= 0);
  if (accountCookie) {
    const cookie = accountCookie.substring(cookieName.length + accountCookie.indexOf(cookieName), accountCookie.length);
    const cookieValue = JSON.parse(cookie);
    if (isNullOrEmpty(cookieValue)) {
      return '';
    }
    return cookieValue;
  }
  return '';
};

export const getKeyBase = (): string => {
  const userInfo = parseCookieAsJsonObject('aws-userInfo=');
  return userInfo?.keybase;
};
